import { capitalize } from 'lodash';
import moulages from '../config/moulages';

function humanize(enumString) {
  // ENUM_WORDS => Enum Words
  const words = enumString.replace(/_/g, ' ').split(' ');
  return words.map(w => capitalize(w)).join(' ');
}

function makeMoulageLabel(moulageKey) {
  const moulage = moulages.find(m => m.key === moulageKey);
  if (moulage) {
    return `${humanize(moulage.category)} ${humanize(moulage.variation)}`;
  }
  return 'Unknown moulage';
}

export default makeMoulageLabel;